"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatorConnection = void 0;
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const Connection_1 = require("../Connection");
const utils_1 = require("@streamr/utils");
const protoToString_1 = require("../../helpers/protoToString");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class SimulatorConnection extends Connection_1.Connection {
    stopped = false;
    localPeerDescriptor;
    targetPeerDescriptor;
    simulator;
    constructor(localPeerDescriptor, targetPeerDescriptor, connectionType, simulator) {
        super(connectionType);
        this.localPeerDescriptor = localPeerDescriptor;
        this.setPeerDescriptor(targetPeerDescriptor);
        this.targetPeerDescriptor = targetPeerDescriptor;
        this.connectionType = connectionType;
        this.simulator = simulator;
        this.send = this.send.bind(this);
        this.close = this.close.bind(this);
        this.connect = this.connect.bind(this);
        this.handleIncomingData = this.handleIncomingData.bind(this);
        this.handleIncomingDisconnection = this.handleIncomingDisconnection.bind(this);
        this.destroy = this.destroy.bind(this);
        this.doDisconnect = this.doDisconnect.bind(this);
    }
    send(data) {
        logger.trace('send()');
        if (!this.stopped) {
            this.simulator.send(this, data);
        }
        else {
            const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
            const targetNodeId = (0, identifiers_1.toNodeId)(this.targetPeerDescriptor);
            logger.error(localNodeId + ', ' + targetNodeId + 'tried to send() on a stopped connection');
        }
    }
    async close(gracefulLeave) {
        const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
        const targetNodeId = (0, identifiers_1.toNodeId)(this.targetPeerDescriptor);
        logger.trace(localNodeId + ', ' + targetNodeId + ' close()');
        if (!this.stopped) {
            logger.trace(localNodeId + ', ' + targetNodeId + ' close() not stopped');
            this.stopped = true;
            try {
                logger.trace(localNodeId + ', ' + targetNodeId + ' close() calling simulator.disconnect()');
                this.simulator.close(this);
                logger.trace(localNodeId + ', ' + targetNodeId + ' close() simulator.disconnect returned');
            }
            catch (e) {
                logger.trace(localNodeId + ', ' + targetNodeId + 'close aborted' + e);
            }
            finally {
                logger.trace(localNodeId + ', ' + targetNodeId + ' calling this.doDisconnect');
                this.doDisconnect(gracefulLeave);
            }
        }
        else {
            logger.trace(localNodeId + ', ' + targetNodeId + ' close() tried to close a stopped connection');
        }
    }
    connect() {
        if (!this.stopped) {
            logger.trace('connect() called');
            this.simulator.connect(this, this.targetPeerDescriptor, (error) => {
                if (error !== undefined) {
                    logger.trace(error);
                    this.doDisconnect(false);
                }
                else {
                    this.emit('connected');
                }
            });
        }
        else {
            logger.trace('tried to connect() a stopped connection');
        }
    }
    handleIncomingData(data) {
        if (!this.stopped) {
            logger.trace('handleIncomingData() ' + (0, protoToString_1.protoToString)(DhtRpc_1.Message.fromBinary(data), DhtRpc_1.Message));
            this.emit('data', data);
        }
        else {
            logger.trace('tried to call handleIncomingData() a stopped connection');
        }
    }
    handleIncomingDisconnection() {
        if (!this.stopped) {
            const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
            logger.trace(localNodeId + ' handleIncomingDisconnection()');
            this.stopped = true;
            this.doDisconnect(false);
        }
        else {
            logger.trace('tried to call handleIncomingDisconnection() a stopped connection');
        }
    }
    destroy() {
        const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
        if (!this.stopped) {
            logger.trace(localNodeId + ' destroy()');
            this.removeAllListeners();
            this.close(false).catch((_e) => { });
        }
        else {
            logger.trace(localNodeId + ' tried to call destroy() a stopped connection');
        }
    }
    doDisconnect(gracefulLeave) {
        const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
        const targetNodeId = (0, identifiers_1.toNodeId)(this.targetPeerDescriptor);
        logger.trace(localNodeId + ' doDisconnect()');
        this.stopped = true;
        logger.trace(localNodeId + ', ' + targetNodeId + ' doDisconnect emitting');
        this.emit('disconnected', gracefulLeave);
    }
}
exports.SimulatorConnection = SimulatorConnection;
//# sourceMappingURL=SimulatorConnection.js.map